<div class="section-gap pt-0">
  <div class="container">
    <div
      class="cta text-center"
      style="
        background-image: url('assets/images/cta-bg-pat.png');
        padding: 90px 0;
        background-size: 25px;
      "
    >
      <div class="overlay-section-overlay cta-image relative">
        <img  loading="lazy"  src="assets/images/bg-sunglass.jpg"    alt="Sunglasses" />
        <div class="cta-content">
          <p>
            <mat-icon aria-hidden="false" class="material-icons text-inverse">
              brightness_5
            </mat-icon>
          </p>
          <h4 class="font-bold mb-4 text-inverse">new arrival</h4>
          <h2 class="mb-4 text-inverse">Sunglasses for Everyone</h2>
          <button mat-raised-button [routerLink]="['/' + lang + '/products']">
            SHOP NOW
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
